module.exports = __webpack_public_path__ + "img/client5.0bf7b2c0.png";